"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Award = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AwardSVG_1 = require("./AwardSVG");
const classnames_1 = __importDefault(require("classnames"));
const useElementSize_1 = require("../../../../hooks/useElementSize");
const AwardColors_1 = require("../config/AwardColors");
const Award = (_a) => {
    var { award, color = 'default', className, ariaHidden = false } = _a, rest = __rest(_a, ["award", "color", "className", "ariaHidden"]);
    const [awardRef, { width, height }] = (0, useElementSize_1.useElementSize)();
    const category = __.trans(`aria.${award.category}`);
    const requiredValue = award.requiredValue ? award.requiredValue : '';
    const obtainedStatus = award.obtainedAt
        ? __.trans('aria.obtained')
        : __.trans('aria.not-obtained');
    const ariaLabelAward = category
        .replace('{{obtained}}', obtainedStatus)
        .replace('{{count}}', requiredValue);
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ ref: awardRef, className: (0, classnames_1.default)('award', className) }, rest, { "aria-hidden": ariaHidden, "aria-label": ariaLabelAward, children: [(0, jsx_runtime_1.jsx)(AwardSVG_1.AwardSVG, { darkColor: AwardColors_1.COLORS[color].darkColor, lightColor: AwardColors_1.COLORS[color].lightColor }), (0, jsx_runtime_1.jsxs)("div", { className: "award-icon-wrapper", style: { width, height: height / 1.9 }, children: [(0, jsx_runtime_1.jsx)("img", { src: `/images/award-icon-${award.category}.svg`, alt: "award", className: "award-icon", style: { height: height / 4.5, marginTop: award.hideRequiredValue ? 0 : height / 15 } }), (0, jsx_runtime_1.jsx)("span", { className: "award-icon-value", style: {
                            fontSize: (height || 180) * 0.0888,
                            display: award.hideRequiredValue ? 'none' : 'inline-block',
                        }, children: award.requiredValue })] })] })));
};
exports.Award = Award;
